import { render, staticRenderFns } from "./RunnitTemplatesPage.vue?vue&type=template&id=8dcf531a&scoped=true"
import script from "./RunnitTemplatesPage.vue?vue&type=script&lang=ts"
export * from "./RunnitTemplatesPage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTemplatesPage.vue?vue&type=style&index=0&id=8dcf531a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcf531a",
  null
  
)

export default component.exports